/**
 * Daily Viral / Inspiracje — wspólna taksonomia nisz, rynków, tonów.
 * Współdzielona między API (walidacja Zod) a web (chipy onboardingu / filtry feedu).
 */

export const NICHES = [
  { key: "agency-marketing", label: "Agencja / Marketing" },
  { key: "saas-tech", label: "SaaS / Tech" },
  { key: "ecommerce", label: "E-commerce" },
  { key: "fitness-health", label: "Fitness / Zdrowie" },
  { key: "finance", label: "Finanse" },
  { key: "real-estate", label: "Nieruchomości" },
  { key: "coaching-courses", label: "Coaching / Kursy" },
  { key: "beauty", label: "Beauty" },
  { key: "food-gastro", label: "Gastro / Food" },
] as const;

export const MARKETS = [
  { key: "US", label: "USA" },
  { key: "GB", label: "UK" },
  { key: "DE", label: "Niemcy" },
  { key: "PL", label: "Polska" },
] as const;

export const TONES = [
  { key: "expert", label: "Ekspercki" },
  { key: "casual", label: "Luźny" },
  { key: "controversial", label: "Kontrowersyjny" },
  { key: "educational", label: "Edukacyjny" },
  { key: "entertaining", label: "Rozrywkowy" },
] as const;

export const VIRAL_PLATFORMS = ["tiktok", "instagram", "youtube"] as const;
export const HANDLE_PLATFORMS = ["instagram", "tiktok"] as const;

export type NicheKey = (typeof NICHES)[number]["key"];
export type MarketKey = (typeof MARKETS)[number]["key"];
export type ToneKey = (typeof TONES)[number]["key"];
export type ViralPlatform = (typeof VIRAL_PLATFORMS)[number];
export type HandlePlatform = (typeof HANDLE_PLATFORMS)[number];

export const NICHE_KEYS = NICHES.map((n) => n.key) as [NicheKey, ...NicheKey[]];
export const MARKET_KEYS = MARKETS.map((m) => m.key) as [MarketKey, ...MarketKey[]];
export const TONE_KEYS = TONES.map((t) => t.key) as [ToneKey, ...ToneKey[]];

const NICHE_LABEL = new Map<string, string>(NICHES.map((n) => [n.key, n.label]));
const MARKET_LABEL = new Map<string, string>(MARKETS.map((m) => [m.key, m.label]));
const TONE_LABEL = new Map<string, string>(TONES.map((t) => [t.key, t.label]));

export const nicheLabel = (key: string): string => NICHE_LABEL.get(key) ?? key;
export const marketLabel = (key: string): string => MARKET_LABEL.get(key) ?? key;
export const toneLabel = (key: string): string => TONE_LABEL.get(key) ?? key;

/** viralScore trzymany jako int x100 (1000 = 10.00x). Format do UI. */
export const formatViralScore = (score: number | null): string =>
  score == null ? "—" : `${(score / 100).toFixed(1)}x`;
